import { getAbTestV2, trackAbTestV2Variant } from 'dibs-ab-tests/exports/clientAbTestV2.ts';

const HP_2TOWER_MODEL_TEST_NAME = 'HP_2TowerModel_May2026';

export const trackHp2TowerModelTest = (): void => {
    trackAbTestV2Variant(HP_2TOWER_MODEL_TEST_NAME);
};

export const isHp2TowerModelTestVariant = (): boolean =>
    getAbTestV2(HP_2TOWER_MODEL_TEST_NAME)?.variant === 'variant';
